import { render, staticRenderFns } from "./data81.vue?vue&type=template&id=167a1062&scoped=true"
import script from "./data81.vue?vue&type=script&lang=js"
export * from "./data81.vue?vue&type=script&lang=js"
import style1 from "./data81.vue?vue&type=style&index=1&id=167a1062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a1062",
  null
  
)

export default component.exports